const formatAmount = function formatAmount(amount, decimalPlaces) {
  return amount.toFixed(decimalPlaces).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1\xa0').replace('.', ',')
}

const formatAmountZLGR = function (amount) {
  const splitted = amount.toString().split('.')
  if (splitted.length === 2) {
    if (splitted[1].length === 1) splitted[1] = splitted[1] + '0'
    return formatAmount(parseInt(splitted[0]), 0) + ' zł, ' + splitted[1] + ' gr'
  }
  return formatAmount(splitted[0])
}

const formatIntAmount = function (amount) {
  return amount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1\xa0')
}

export { formatAmount, formatIntAmount, formatAmountZLGR }
